import React from 'react';

import { Icon } from '@chakra-ui/react';

export const ForwardingRuleIcon = props => (
  <Icon viewBox="0 0 721 720" w="full" h="full" color="inherit" {...props}>
    <g transform="translate(-260 18)">
      <g>
        <g>
          <g>
            <g>
              <path
                d="M813.353 204.44C830.662 221.747 839.314 230.4 843.875 241.404 848.43 252.408 848.43 264.646 848.43 289.121L848.43 508.97C848.43 565.426 848.43 593.652 830.892 611.19 813.353 628.728 785.128 628.728 728.672 628.728L549.035 628.728C492.582 628.728 464.354 628.728 446.815 611.19 429.277 593.652 429.277 565.426 429.277 508.97L429.277 209.577C429.277 153.122 429.277 124.895 446.815 107.357 464.354 89.8185 492.582 89.8185 549.035 89.8185L649.126 89.8185C673.604 89.8185 685.841 89.8185 696.844 94.3766 707.85 98.9347 716.502 107.588 733.811 124.895L813.353 204.44Z"
                stroke="currentColor"
                strokeWidth="28.5148"
                strokeLinecap="butt"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1 0 0 1.00202 -18.2903 -18)"
              />
              <path
                d="M676.08 268.161 731.581 317.494C753.497 336.974 764.454 346.718 764.454 359.265 764.454 371.813 753.497 381.554 731.581 401.037L676.08 450.369C666.078 459.261 661.073 463.709 656.951 461.854 652.825 460.004 652.825 453.313 652.825 439.926L652.825 407.169C602.527 407.169 548.039 431.12 527.081 471.04 527.081 343.298 601.598 311.362 652.825 311.362L652.825 278.603C652.825 265.219 652.825 258.526 656.951 256.674 661.073 254.822 666.078 259.269 676.08 268.161Z"
                stroke="currentColor"
                strokeWidth="28.5148"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeMiterlimit="4"
                fill="none"
                fillRule="nonzero"
                transform="matrix(1 0 0 1.00202 -18.2903 -18)"
              />
            </g>
          </g>
        </g>
      </g>
    </g>
  </Icon>
);
